import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import {
  getIsCurrentUserCreatorOrEditorOfDashboard,
  trackDashboardEvent,
} from '@modules/dashboard/helpers';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { LinkRounded } from '@mui/icons-material';
import { Button, Stack, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useGetUser } from 'v2/core/services/user';
import { DashboardShareAvatarGroup } from '../DashboardShareAvatarGroup';
import { DashboardShareDrawer } from '../DashboardShareDrawer';

export const DashboardShareButton = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { id: currentUserID } = useGetUser();
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);

  const { showSuccessNotification, showErrorNotification } =
    useNotificationContext();

  if (!dashboard) {
    return null;
  }

  const isDraftDashboard = !dashboard.id;

  const editors = dashboard.editors || [];

  if (
    !getIsCurrentUserCreatorOrEditorOfDashboard(
      editors,
      currentUserID,
      dashboard.createdBy.id,
    )
  ) {
    return null;
  }

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const onCopyLink = () => {
    const link = window.location.href.toString();
    try {
      navigator.clipboard.writeText(link);
      showSuccessNotification({
        contentComponent: 'Link copied to clipboard!',
        props: { isClosable: true },
      });
      trackDashboardEvent({
        eventName: 'Dashboard Link Copied',
        dashboardLink: link,
      });
    } catch {
      showErrorNotification({
        contentComponent:
          'Some error occurred while copying. Please copy the link manually from the URL.',
        props: { isClosable: true },
      });
    }
  };

  return (
    <>
      <Stack direction="row">
        {!isDraftDashboard && (
          <Tooltip title="Copy Link to clipboard. Anyone in your organization can view this.">
            <Button
              variant="outlined"
              sx={{
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderRight: 'none',
                '&:hover': {
                  borderRight: 'none',
                },
                minWidth: 0,
                width: 'auto',
                px: 1,
              }}
              onClick={onCopyLink}
              aria-label="Copy Dashboard Link"
            >
              <LinkRounded />
            </Button>
          </Tooltip>
        )}
        <Tooltip title="Invite people to collaborate on this Dashboard">
          <Button
            variant="outlined"
            onClick={openDrawer}
            {...(!isDraftDashboard && {
              sx: {
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
              },
            })}
            endIcon={<DashboardShareAvatarGroup editors={editors} />}
          >
            Share
          </Button>
        </Tooltip>
      </Stack>
      <DashboardShareDrawer
        isOpen={isDrawerOpen}
        onClose={closeDrawer}
        onCopyDashboardLink={onCopyLink}
      />
    </>
  );
};
